import axios from 'axios'
import {api} from './requestGraphql.js'
import request from "@/api/request";
import {getCookie} from "@/helpers";

const getOffers = async data => {
  try {

    const result = await axios.get(`${process.env.VUE_APP_BACKOFFICE_BASE_URL}/offers/getOffers`, {
      params: data.filters,
      headers: {
        'Authorization': data.token,
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': '*'
      }
    })

    return result.data

  } catch (err) {
    console.error(err)
  }
}

const getAdvertisers = async data => {
  try {

    const result = await axios.get(`${process.env.VUE_APP_BACKOFFICE_BASE_URL}/offers/getAdvertisers`, {
      headers: {
        'Authorization': data.token,
        'Referrer-Police': 'strict-origin-when-cross-origin',
        'Access-Control-Allow-Origin': '*'
      }
    })

    return result.data

  } catch (err) {
    console.error(err)
  }
}

const sflAdvertisersManagers = async () => {
  try {
    const res = await api.post(
      '', {
        query: `
					{
						getSflAdvertisersManagers{
								id    
								firstName
								lastName
						} 
					}
					`,
      }
    )

    let response = res.data.data.getSflAdvertisersManagers
    // console.log(` *** getSflAdvertisersManagers from DB response count:${response.length}`)
    return response
  } catch (e) {
    console.log(e)
  }

}

const sflAdvertisers = async (data) => {
  let preparedFilters = ''
  for (const filter in data.filters) {
    preparedFilters += (!!data.filters[filter]) ?
        `${filter}: "${data.filters[filter]}"` : ''
  }
  try {
    const res = await api.post(
        '', {
          query: `
          {
            getSflAdvertisers(pagination: {
                  page: ${data.page},
                  limit: ${data.limit}
                }, sorting: {
                  orderBy: "${data.orderBy}",
                  orderDirectionAsc: ${data.orderDirectionAsc}
                }, filters: {${preparedFilters}}){
              id    
              name
              margin
            } 
          }
        `,
        }
    )
    return res.data.data.getSflAdvertisers
  } catch (e) {
    console.log(e)
  }
}

const getSflOffers = async (data) => {

  try {

    let payload = data && data.payload ? JSON.stringify(data.payload).replace(/"/g, '\\"') : ''
    payload = `(payload:"${payload}")`

    const res = await api.post(
      '', {
        query: `
          {
            getSflOffers ${payload}{
              count,
              data {
                id
                name
                offerNameId
                status
                type
                payIn
                payOut
                currencyId
                dateAdded
                dateUpdated
                verticalId
                verticalName
                advertiserName
                advertiserId
                isCpmOptionEnabled
                descriptions
                payoutPercent
                defaultLandingPageId
                programId
                programName
                nameLandingPage 
                landingPageUrl
                landingPageId
                countOfCampaigns
                aggregatedOfferLPurl
                aggregatedOfferLPcount
                currencyName
                currencySymbol
                conversionType
                managerName
                minPayIn
                maxPayIn
                minPayOut
                maxPayOut
                isRestricted
                marginType
                featured
                variantId
                externalId
                internalNotes
                affiliateMultiPings
              }
            }
          }
        `,
      }
    )

    let response = res.data.data.getSflOffers
    console.log(`getOffers response count :`, response.count)
    return response
  } catch (e) {
    console.log(e)
  }

}

const getSflOfferAdvertiserIds = async (data) => {

  const search = data && `(search: "${data.search}")` || ''

  try {
    const res = await api.post(
      '', {
        query: `
          {
            getSflOfferAdvertiserIds ${search}{
              advertiserId
            }
          }
        `,
      }
    )

    let response = res.data.data.getSflOfferAdvertiserIds
    console.log(`getSflOfferAdvertiserIds response count :`, response.length)
    return response
  } catch (e) {
    console.log(e)
  }

}

const getSflOfferAdvertiserNames = async (data) => {

  try {

    let payload = data && JSON.stringify(data.filters).replace(/"/g, '\\"') || ''
    payload = `(filters:"${payload}")`

    const res = await api.post(
        '', {
          query: `
          {
            getSflOfferAdvertiserNames ${payload}{
              advertiserName
            }
          }
        `,
        }
    )

    let response = res.data.data.getSflOfferAdvertiserNames
    console.log(`getSflOfferAdvertiserNames response count :`, response.length)
    return response
  } catch (e) {
    console.log(e)
  }
}

const getSflOfferExternalIds = async (data) => {
  try {
    let payload = data && JSON.stringify(data.filters).replace(/"/g, '\\"') || '';
    payload = `(filters:"${payload}")`;

    const res = await api.post('', {
      query: `
        {
          getSflOfferExternalIds ${payload} {
            externalId
          }
        }
      `,
    });

    let response = res.data.data.getSflOfferExternalIds;
    console.log(`getSflOfferExternalIds response count:`, response.length);
    return response;
  } catch (e) {
    console.error('Error in getSflOfferExternalIds:', e);
    return [];
  }
};


const getSflOfferManagerNames = async (data) => {

  try {

    let payload = data && JSON.stringify(data.filters).replace(/"/g, '\\"') || ''
    payload = `(filters:"${payload}")`

    const res = await api.post(
      '', {
        query: `
          {
            getSflOfferManagerNames ${payload}{
              managerId
              managerName
            }
          }
        `,
      }
    )

    let response = res.data.data.getSflOfferManagerNames
    console.log(`getSflOfferManagerNames response count :`, response.length)
    return response
  } catch (e) {
    console.log(e)
  }
}

const getSflOfferVerticalNames = async (data) => {

  try {

    let payload = data && JSON.stringify(data.filters).replace(/"/g, '\\"') || ''
    payload = `(filters:"${payload}")`

    const res = await api.post(
        '', {
          query: `
          {
            getSflOfferVerticalNames ${payload}{
              verticalName
            }
          }
        `,
        }
    )

    let response = res.data.data.getSflOfferVerticalNames
    console.log(`getSflOfferVerticalNames response count :`, response.length)
    return response
  } catch (e) {
    console.log(e)
  }
}

const getSflCurrencies = async (data) => {

  const search = data && `(search: "${data.search}")` || ''

  try {
    const res = await api.post(
      '', {
        query: `
          {
            getSflCurrencies ${search}{
              currencyName
            }
          }
        `,
      }
    )

    let response = res.data.data.getSflCurrencies
    console.log(`getSflCurrencies response count :`, response.length)
    return response
  } catch (e) {
    console.log(e)
  }
}

const getSflOfferNames = async (data) => {

  try {

    let payload = data && JSON.stringify(data.filters).replace(/"/g, '\\"') || ''
    payload = `(filters:"${payload}")`

    const res = await api.post(
      '', {
        query: `
          {
            getSflOfferNames ${payload}{
              name
            }
          }
        `,
      }
    )

    let response = res.data.data.getSflOfferNames
    console.log(`getSflOfferNames response count :`, response.length)
    return response
  } catch (e) {
    console.log(e)
  }
}

const getSflOfferPaysIn = async (data) => {

  const search = data && `(search: "${data.search}")` || ''

  try {
    const res = await api.post(
      '', {
        query: `
          {
            getSflOfferPaysIn ${search}{
              payIn
            }
          }
        `,
      }
    )

    let response = res.data.data.getSflOfferPaysIn
    console.log(`getSflOfferPaysIn response count :`, response.length)
    return response
  } catch (e) {
    console.log(e)
  }
}

const getSflOfferPaysOut = async (data) => {

  const search = data && `(search: "${data.search}")` || ''

  try {
    const res = await api.post(
      '', {
        query: `
          {
            getSflOfferPaysOut ${search}{
              payOut
            }
          }
        `,
      }
    )

    let response = res.data.data.getSflOfferPaysOut
    console.log(`getSflOfferPaysOut response count :`, response.length)
    return response
  } catch (e) {
    console.log(e)
  }
}

const getSflOfferStatuses = async (data) => {

  try {
    let payload = data && JSON.stringify(data.filters).replace(/"/g, '\\"') || ''
    payload = `(filters:"${payload}")`

    const res = await api.post(
      '', {
        query: `
          {
            getSflOfferStatuses ${payload}{
              statuses
            }
          }
        `,
      }
    )

    let response = res.data.data.getSflOfferStatuses
    console.log(`getSflOfferAdvertiserIds response count :`, response.length)
    return response
  } catch (e) {
    console.log(e)
  }

}

const getSflOfferTypes = async (data) => {
  try {
    let payload = data && JSON.stringify(data.filters).replace(/"/g, '\\"') || ''
    payload = `(filters:"${payload}")`
    const res = await api.post(
        '', {
          query: `
          {
            getSflOfferTypes ${payload}{
              types
            }
          }
        `,
        }
    )
    let response = res.data.data.getSflOfferTypes
    return response
  } catch (e) {
    console.log(e)
  }
}

const getSflOfferIds = async (data) => {
  try {
    let payload = data && JSON.stringify(data.filters).replace(/"/g, '\\"') || ''
    payload = `(filters:"${payload}")`
    const res = await api.post(
        '', {
          query: `
          {
            getSflOfferIds ${payload}{
              ids
            }
          }
        `,
        }
    )
    let response = res.data.data.getSflOfferIds
    return response
  } catch (e) {
    console.log(e)
  }
}

const createMassCampaigns = async (data) => {

  let affiliatesOffers = JSON.stringify(data).replace(/"/g, '\\"')

  try {
    const res = await api.post(
      '', {
        query: `
          mutation{
            createMassCampaigns(
              affiliatesOffersData:"${affiliatesOffers}"
            ){
              result
            }
          },

        `,
      }
    )

    let response = res.data.data.createMassCampaigns
    console.log(`\nCreateMassCampaigns : { ${JSON.stringify(response)} } `)
    return response
  } catch (e) {
      console.log(e)
  }

}

const getFilter = async (data) => {
  const preparedFilter = []
  if(data.filter) {
    for (let i = 0; i < data.filter.length; i++) {
      preparedFilter.push(
          (!!data.filter[i]) ? `{ field: "${data.filter[i].field}", value: [${data.filter[i].value.map(v => `"${v}"`)}] }` : ''
      )
    }
  }

  data.filter = preparedFilter ? `filter:[${preparedFilter.join(',')}]` : ''

  const result = await request.post(`/graphql`, {
        query: `
          {
            offersFilterData(name: "${data.name}", searchFilter: "${data.searchFilter || ''}", ${data.filter}) {
              key,
              value
            }
          }
        `
      },
      {
        headers: {
          'Authorization': getCookie('accessToken'),
          'Referrer-Police': 'strict-origin-when-cross-origin',
          'Access-Control-Allow-Origin': '*',
          'workspace': localStorage.getItem('workspace') || 'ac'
        }
      }
  )

  if(result.status === 200) {
    const prettyData = [];
    if(result.data.data.offersFilterData) {
      for(let i = 0; i < result.data.data.offersFilterData.length; i++) {
        prettyData.push(result.data.data.offersFilterData[i]);
      }
      return prettyData;
    }
  }
}

const getAffiliates = async (data) => {

  const id_ = `(id: ${data.id})`;

  try {
    console.time(`sflAffiliates`)
    const res = await api.post(
        '', {
          query: `
          {
            getOfferAffiliates${id_}{
              id    
              name
              email
              status
            } 
          }
        `,
        }
    );

    let response = res.data.data.getOfferAffiliates;
    console.log(` *** getSflAffiliates from DB response count:${response.length}`);
    console.timeEnd(`sflAffiliates`)
    return response
  } catch (e) {
    console.log(e)
  }

}

const getCampaigns = async (data) => {

  const id_ = `(id: ${data.id})`;

  try {
    console.time(`sflCampaigns`);
    const res = await api.post(
        '', {
          query: `
          {
            getOfferCampaigns${id_}{
              id    
              name
              status
              payOut
              affiliate
              affiliateStatus
            } 
          }
        `,
        }
    );

    let response = res.data.data.getOfferCampaigns;
    console.log(` *** getSflAffiliates from DB response count:${response.length}`);
    console.timeEnd(`sflCampaigns`)
    return response
  } catch (e) {
    console.log(e)
  }

}

const getHistory = async (data) => {

  const id_ = `(id: ${data.id})`;

  try {
    console.time(`logs`)
    const res = await api.post(
        '', {
          query: `
          {
            getOfferHistory${id_}{
              user
               action
               dateAdded
               logs
            } 
          }
        `,
        }
    );

    let response = res.data.data.getOfferHistory;
    console.log(` *** getLogs from DB response count:${response.length}`);
    console.timeEnd(`logs`)
    return response
  } catch (e) {
    console.log(e)
  }

}

const getSflOfferProgramNames = async (data) => {
  try {

    let payload = data && JSON.stringify(data.filters).replace(/"/g, '\\"') || ''
    payload = `(filters:"${payload}")`

    const res = await api.post(
        '', {
          query: `
          {
            getSflOfferProgramNames ${payload}{
              programName
              programId
            }
          }
        `,
        }
    )

    let response = res.data.data.getSflOfferProgramNames
    console.log(`!getSflOfferProgramNames response count :`, response.length)
    return response
  } catch (e) {
    console.log(e)
  }

}

export default {
  getOffers,
  getAdvertisers,
  sflAdvertisersManagers,
  sflAdvertisers,
  getSflOffers,
  getSflOfferAdvertiserIds,
  getSflOfferAdvertiserNames,
  getSflOfferExternalIds,
  getSflOfferManagerNames,
  getSflOfferNames,
  getSflOfferPaysIn,
  getSflOfferPaysOut,
  getSflOfferVerticalNames,
  getSflOfferStatuses,
  getSflOfferTypes,
  getSflOfferIds,
  getSflOfferProgramNames,
  getSflCurrencies,
  createMassCampaigns,
  getFilter,
  getAffiliates,
  getCampaigns,
  getHistory
}
